// @flow

type Listener = (e?: Event) => void
type State = 'running' | 'stopped' | 'awaiting' | 'not_started'
let supportsPassive = null

export class GlobaListener {
  listeners: Listener[] = []
  state: State = 'not_started'
  constructor() {
    if (typeof window === 'undefined') {
      return
    }
    if (typeof supportsPassive !== 'undefined') {
      supportsPassive = supportsPassiveEventlisteners()
    }
  }

  start = () => {
    this.state = 'awaiting'
    requestAnimationFrame(() => this.listener())
  }

  listener = (e?: Event) => {
    if (this.state === 'running') {
      return
    }

    this.state = 'running'
    this.listeners.forEach(listener => listener(e))

    this.state = 'awaiting'
    if (!this.state !== 'stopped') {
      requestAnimationFrame(() => this.listener())
    }
  }

  add = (listener: Listener) => {
    this.listeners.push(listener)
    if (['not_started', 'stopped'].indexOf(this.state) >= 0) {
      this.start()
    }
    return () => this.remove(listener)
  }

  remove = (listener: Listener) => {
    const index = this.listeners.indexOf(listener)
    if (index !== -1) this.listeners.splice(index, 1)
    if (this.listeners.length === 0) {
      this.destroy()
    }
  }

  destroy = () => {
    this.state = 'stopped'
    // window.removeEventListener(this.type, this.listener)
  }
}

export default GlobaListener

function supportsPassiveEventlisteners() {
  var supportsPassive = false
  try {
    var opts = Object.defineProperty({}, 'passive', {
      value: '',
      get: function() {
        supportsPassive = true
      }
    })
    window.addEventListener('testPassive', null, opts)
    window.removeEventListener('testPassive', null, opts)
  } catch (e) {}
  return supportsPassive
}
